module.exports = __webpack_public_path__ + "img/back_buttons_quantity.38669b2d.png";